class CartRemoveButton extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("click", (event) => {
			event.preventDefault();
			const cartItems =
				this.closest("cart-items") || this.closest("cart-drawer-items");
			cartItems.updateQuantity(this.dataset.index, 0);
		});
	}
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();

		//this.lineItemStatusElement =
		//	document.getElementById("shopping-cart-line-item-status") ||
		//	document.getElementById("CartDrawer-LineItemStatus");

		//this.currentItemCount = Array.from(
		//	this.querySelectorAll('[name="updates[]"]')
		//).reduce(
		//	(total, quantityInput) => total + parseInt(quantityInput.value),
		//	0
		//);

		//this.debouncedOnChange = debounce((event) => {
		//	this.onChange(event);
		//}, 300);

		//this.addEventListener("change", this.debouncedOnChange.bind(this));
		this.lineItemStatusElement =
			document.getElementById("shopping-cart-line-item-status") ||
			document.getElementById("CartDrawer-LineItemStatus");
		const debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, ON_CHANGE_DEBOUNCE_TIMER);
		this.addEventListener("change", debouncedOnChange.bind(this));
	}
	cartUpdateUnsubscriber = undefined;
	connectedCallback() {
		this.cartUpdateUnsubscriber = subscribe(
			PUB_SUB_EVENTS.cartUpdate,
			(event) => {
				if (event.source === "cart-items") {
					return;
				}
				this.onCartUpdate();
			}
		);
	}
	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber();
		}
	}

	onChange(event) {
		this.updateQuantity(
			event.target.dataset.index,
			event.target.value,
			document.activeElement.getAttribute("name")
		);
	}
	onCartUpdate() {
		fetch(`${routes.cart_url}?section_id=main-cart-items`)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				const sourceQty = html.querySelector("cart-items");
				this.innerHTML = sourceQty.innerHTML;
			})
			.catch((e) => {
				console.error(e);
			});
	}
	getSectionsToRender() {
		return [
			{
				id: "main-cart-items",
				section: document.getElementById("main-cart-items").dataset.id,
				selector: ".js-contents",
			},
			{
				id: "main-cart-footer",
				section: document.getElementById("main-cart-footer").dataset.id,
				selector: ".js-contents-2",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
			{
				id: "cart-icon-bubble-mobile",
				section: "cart-icon-bubble-mobile",
				selector: ".shopify-section",
			},
			{
				id: "cart-live-region-text",
				section: "cart-live-region-text",
				selector: ".shopify-section",
			},
		];
	}

	async updateQuantity(line, quantity, name) {
      if(document.getElementById(`Quantity-${line}`)){
		let product = document.getElementById(`Quantity-${line}`).getAttribute('productHandle')
		let isGift = await CDcheckForGift(product)
		console.log(isGift)
		if(isGift && quantity > 1){
			this.updateLiveRegions(line,'Solo puedes comprar una Gift Card por orden')
			document.getElementById(`Quantity-${line}`).value = 1
			return
		}
      }
		this.enableLoading(line);
		this.querySelectorAll(".quantity__button").forEach((button) =>
			button.classList.add("disabled")
		);
		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});
		fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				const quantityElement =
					document.getElementById(`Quantity-${line}`) ||
					document.getElementById(`Drawer-quantity-${line}`);
				const items = document.querySelectorAll(".cart-item");
				if (parsedState.errors) {
					quantityElement.value = quantityElement.getAttribute("value");
					this.updateLiveRegions(line, parsedState.errors);
					return;
				}
				this.classList.toggle("is-empty", parsedState.item_count === 0);
				const cartDrawerWrapper = document.querySelector("cart-drawer");
				const cartFooter = document.getElementById("section-cart__header");
				const cartContent = document.getElementById("section-cart__content");
				const emptyCartHeader = document.getElementById("empty-cart__content");
				if (emptyCartHeader)
					emptyCartHeader.classList.toggle(
						"is-empty",
						parsedState.item_count !== 0
					);
				if (cartFooter)
					cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
				if (cartContent)
					cartContent.classList.toggle(
						"is-empty",
						parsedState.item_count === 0
					);
				if (cartDrawerWrapper)
					cartDrawerWrapper.classList.toggle(
						"is-empty",
						parsedState.item_count === 0
					);
				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document
							.getElementById(section.id)
							.querySelector(section.selector) ||
						document.getElementById(section.id);
					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector
					);
				});
				const updatedValue = parsedState.items[line - 1]
					? parsedState.items[line - 1].quantity
					: undefined;
				let message = "";
				if (
					items.length === parsedState.items.length &&
					updatedValue !== parseInt(quantityElement.value)
				) {
					if (typeof updatedValue === "undefined") {
						message = window.cartStrings.error;
					} else {
						message = window.cartStrings.quantityError.replace(
							"[quantity]",
							updatedValue
						);
					}
				}
				this.updateLiveRegions(line, message);
				const lineItem =
					document.getElementById(`CartItem-${line}`) ||
					document.getElementById(`CartDrawer-Item-${line}`);
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper
						? trapFocus(
								cartDrawerWrapper,
								lineItem.querySelector(`[name="${name}"]`)
						  )
						: lineItem.querySelector(`[name="${name}"]`).focus();
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper.querySelector(".drawer__inner-empty"),
						cartDrawerWrapper.querySelector("a")
					);
				} else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper,
						document.querySelector(".cart-item__name")
					);
				}
				publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
				setTimeout(() => {
					ncaddToken()
					uploadCart()
                    executeInCartUpdate()
				  }, 500);
			})
			.catch(() => {
				this.querySelectorAll(".loading-overlay").forEach((overlay) =>
					overlay.classList.add("hidden")
				);
				this.querySelectorAll(".quantity__button").forEach((button) =>
					button.classList.remove("disabled")
				);
				const errors =
					document.getElementById("cart-errors") ||
					document.getElementById("CartDrawer-CartErrors");
				errors.textContent = window.cartStrings.error;
			})
			.finally(() => {
				this.querySelectorAll(".quantity__button").forEach((button) =>
					button.classList.remove("disabled")
				);
				this.disableLoading(line);
			});
	}

	updateLiveRegions(line, message) {
		const lineItemError =
			document.getElementById(`Line-item-error-${line}`) ||
			document.getElementById(`CartDrawer-LineItemError-${line}`);
		if (lineItemError)
			lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
		this.lineItemStatusElement.setAttribute("aria-hidden", true);
		const cartStatus =
			document.getElementById("cart-live-region-text") ||
			document.getElementById("CartDrawer-LiveRegionText");
		cartStatus.setAttribute("aria-hidden", false);
		setTimeout(() => {
			cartStatus.setAttribute("aria-hidden", true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");

		mainCartItems.classList.add("cart__items--disabled");
		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
			overlay.classList.remove("hidden")
		);

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute("aria-hidden", false);
	}

	disableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.remove("cart__items--disabled");
		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		);
		cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
		cartDrawerItemElements.forEach((overlay) =>
			overlay.classList.add("hidden")
		);
	}
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					"change",
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{ body },
						});
					}, ON_CHANGE_DEBOUNCE_TIMER)
				);
			}
		}
	);
}


async function CDcheckForGift(productHandle) {
	let hasGift = false;
  let sku_list = ['9909909_000250','9909909_000500','9909909_000600','9909909_000700','9909909_000800','9909909_000900','9909909_001000','9909909_002000']
	await fetch(`/products/${productHandle}.js`)
		.then(response => response.json())
		.then(product => {
          for(let variant of product.variants){
		  if (sku_list.includes(variant.sku)) {
			hasGift = true;
		  }
          }
		})
		.catch(error => {
		  console.error(`Error al obtener el producto:`, error);
		});
	return hasGift
  }


async function generalGetCurrentCart() {
	let cart
    await fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        return response.json().then(error => { throw new Error(error.message); });
      }
      return response.json();
    })
    .then(data => {
        cart = data
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    return cart
  }

function executeInCartUpdate(){
  /* const splideTrack = document.createElement('div');
  splideTrack.className = 'splide__track';
  
  const splideList = document.createElement('ul');
  splideList.className = 'splide__list';
  const doc = document.querySelector('.shopify-section-group-header-group .nosto_element .nosto-carousel')
  const liElements = doc.children;
  for(let element of liElements){
    const slide = document.createElement('li');
    slide.className = `${element.className} splide__slide`;
    slide.innerHTML = element.innerHTML; // Copiar el contenido del <li>
    splideList.appendChild(slide);
  }
  splideTrack.appendChild(splideList);
  $('#Nosto-slider1').html(splideTrack)
  $('#Nosto-slider1').prepend('<h3 style="padding-left:15px">Los más vendidos</h3>')
  new Splide('#Nosto-slider1', {
    type: 'loop',
    perPage: 4,
    perMove: 1,
    focus  : 0,
    omitEnd: true,
    breakpoints: {
      600: {
        perPage: 3, // 2 slides visibles en pantallas <= 768px
      },
      400: {
        perPage: 2, // 1 slide visible en pantallas <= 480px
      },
    },
  }).mount() */
  checkCeroItems()
  //loadNostoCarousel('persistentcart-nosto-1','persistentcart-nosto-1',true)
  //loadNostoCarousel('persistentcart-nosto-2','persistentcart-nosto-2',true)
  ////loadNostoCarousel('persistentcart-nosto-3','persistentcart-nosto-3',true)
}

async function checkCeroItems(){
  let cart = await generalGetCurrentCart()
  for(const item of cart.items){
    let res = await fetch(`https://shasamx.myshopify.com/products/${item.handle}.js`);
    let product = await res.json();
    if(product.price == 0){
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: product.key,
          quantity: 0
        })
      })
      .then(async data => {
        await updateCart()
      });
    }
  }
}

async function loadNostoCarousel(elementId,nostoId,needsProductId){
  if(needsProductId){
    let cart = await generalGetCurrentCart()
    let productId = cart.items[0].product_id + ''
    nostojs(api => {
      api.createRecommendationRequest({includeTagging:true})
        .setProducts([{product_id: productId}])
        .setElements([nostoId])
        .load()
        .then(response => {
          let recommendations = response.recommendations
          if (recommendations && Object.keys(recommendations).length > 0) {
              const firstKey = Object.keys(recommendations)[0];
              const content = recommendations[firstKey];
            content.html = content.html.replace('</>','</p>')
              document.getElementById(elementId).innerHTML = content
              parent.addNostoCarousel(elementId)
                createCarousel(elementId)
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  }
  else{
    /* nostojs(api => {
      api.createRecommendationRequest({includeTagging:true})
        .setElements([nostoId])
        .load()
        .then(response => {
          let recommendations = response.recommendations
          if (recommendations && Object.keys(recommendations).length > 0) {
              const firstKey = Object.keys(recommendations)[0];
              const content = recommendations[firstKey];
              document.getElementById(elementId).innerHTML = content
              parent.addNostoCarousel(elementId)
                createCarousel(elementId)
          }
        });
    }); */
  }
}

function createCarousel(elementId){
  setTimeout(() => {
    const splideTrack = document.createElement('div');
    splideTrack.className = 'splide__track';
    
    const splideList = document.createElement('ul');
    splideList.className = 'splide__list';
    const doc = document.getElementById(elementId)
    const liElements = doc.querySelector('.nosto-carousel').children;
    for(let element of liElements){
      if(element.innerHTML){
        const slide = document.createElement('li');
        slide.className = `${element.className} splide__slide`;
        slide.innerHTML = element.innerHTML; // Copiar el contenido del <li>
        splideList.appendChild(slide);
      }
    }
    const title = doc.querySelector('.title').textContent
    splideTrack.appendChild(splideList);
    document.getElementById(elementId).innerHTML = "";
    $('#'+elementId).html(splideTrack)
    $('#'+elementId).prepend('<h3 style="padding-left:15px">'+title+'</h3>')
    new Splide('#'+elementId, {
      type: 'loop',
      perPage: 4,
      perMove: 1,
      focus  : 0,
      omitEnd: true,
      breakpoints: {
        600: {
          perPage: 3, // 2 slides visibles en pantallas <= 768px
        },
        400: {
          perPage: 2, // 1 slide visible en pantallas <= 480px
        },
      },
    }).mount()
  }, 1200);
}

